import * as yup from 'yup';

const nullableDateField = yup
  .date()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue === null || originalValue === undefined) {
      return null;
    }

    return value;
  });

export const expandServiceSchema = yup.object({
  serviceStartDt: nullableDateField.required('서비스 시작일을 선택하세요.'),
  exp: nullableDateField
    .required('서비스 종료일을 선택하세요.')
    .test('service-period-order', '서비스 종료일은 시작일 이후여야 합니다.', function (value) {
      const { serviceStartDt } = this.parent as { serviceStartDt?: Date | null };

      if (!serviceStartDt || !value) {
        return true;
      }

      return value >= serviceStartDt;
    }),
  memo: yup.string(),
});
